import { useState, useEffect, useCallback } from 'react'
import lodash from 'lodash'
import BackOfficeAPIClient from "../clients/BackofficeAPIClient"
import { Societe } from "../types/Societe"

interface UseSocietesReturn {
    societes: Societe[]
    loading: boolean
    fetchSocietes: () => Promise<void>
}

const useSocietes = (): UseSocietesReturn => {
    const backofficeApiClient = new BackOfficeAPIClient();
    const [societes, setSocietes] = useState<Societe[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const fetchSocietes = useCallback(async () => {
        try {
            setLoading(true)
            let data = await backofficeApiClient.get<Societe[]>("/societes")
            data = lodash.sortBy(data, (societe) => societe.Libelle)

            setSocietes(data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchSocietes()
    }, [fetchSocietes])

    return {
        societes,
        loading,
        fetchSocietes
    }
}

export default useSocietes
